module.exports = __webpack_public_path__ + "static/media/up-arrow.edda7e5a.svg";